<template>
  <nav class="app-nav">
    <div class="nav-inner">
      <router-link to="/" class="nav-logo">ColorThinking</router-link>

      <div v-if="!mobile" class="nav-links">
        <router-link to="/" class="nav-link" :class="{ on: isActive('/') }">首页</router-link>
        <router-link
          v-for="p in pageProducts"
          :key="p.id"
          :to="`/home/${p.id}`"
          class="nav-link"
          :class="{ on: isActive(`/home/${p.id}`) }"
        >{{ p.name }}</router-link>
        <router-link to="/about" class="nav-link" :class="{ on: isActive('/about') }">关于</router-link>
      </div>

      <v-menu v-else>
        <template v-slot:activator="{ props }">
          <v-btn icon="mdi-menu" variant="text" v-bind="props" aria-label="菜单" />
        </template>
        <v-list>
          <v-list-item @click="go('/')">
            <v-list-item-title>首页</v-list-item-title>
          </v-list-item>
          <v-list-item v-for="p in pageProducts" :key="p.id" @click="go(`/home/${p.id}`)">
            <v-list-item-title>{{ p.name }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="go('/about')">
            <v-list-item-title>关于</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </nav>
</template>

<script setup>
import { useDisplay } from 'vuetify'
import { useRoute, useRouter } from 'vue-router'
import { products } from '@/data/products'

const route = useRoute()
const router = useRouter()
const { mobile } = useDisplay()

const pageProducts = products.filter(p => p.page)

const isActive = (path) => route.path === path

const go = (link) => {
  router.push(link)
}
</script>

<style scoped>
.app-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}

.nav-inner {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: min(1180px, calc(100% - 3rem));
  margin: 0 auto;
  box-shadow: 0 1px 0 rgba(20, 35, 65, 0.08);
}

.nav-logo {
  font-size: 1.3rem;
  font-weight: 800;
  color: #2d85f0;
  text-decoration: none;
  letter-spacing: 0.5px;
}

.nav-links {
  display: flex;
  gap: 1.6rem;
}

.nav-link {
  color: #5c6470;
  text-decoration: none;
  font-size: 0.92rem;
  font-weight: 500;
  transition: color 0.25s ease;
}

.nav-link:hover {
  color: #2d85f0;
}

.nav-link.on {
  color: #2d85f0;
  font-weight: 600;
}
</style>
